import React, { useLayoutEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import { gsap } from 'gsap';

import styles from './InfiniteBanner.scss';

type props = {
  data: {
    id: string;
    text: string;
  }[];
  textClassName?: string;
  delay?: number;
};
const InfiniteBanner = ({ data, textClassName = '', delay = 0 }: props) => {
  const { isDesktop } = useLayoutContext();

  useLayoutEffect(() => {
    const timeline = gsap.timeline({ repeat: -1, delay: delay });

    data.forEach((item) => {
      gsap.set(`#${item.id}`, { display: 'none', y: 120 });
      timeline
        .to(`#${item.id}`, { display: 'block' }, '0')
        .to(`#${item.id}`, { y: 0 }, '+=0.25')
        .to(`#${item.id}`, { y: isDesktop ? -120 : -90, duration: 0.4 }, '+=1.25');
    });
  }, []);

  return (
    <div className={styles.bannerContainer}>
      {data.map((item) => (
        <div className={styles.animatedContainer} key={item.id}>
          <span id={item.id} className={textClassName}>
            {item.text}
          </span>
        </div>
      ))}
    </div>
  );
};

export default InfiniteBanner;
